interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
}

/// Accessible on/off switch — design system v2 §06 `.switch`: 42x24 track,
/// accent when on, ink-300 when off, 18px white knob with elevation 1.
export function Toggle({ checked, onChange, disabled, 'aria-label': ariaLabel }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-[42px] shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-brand focus-visible:!rounded-full disabled:cursor-not-allowed disabled:opacity-45 ${
        checked ? 'bg-admin' : 'bg-ink-300'
      }`}
    >
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute left-[3px] top-[3px] h-[18px] w-[18px] rounded-full bg-white shadow-elev-1 transition-transform duration-200 ease-brand ${
          checked ? 'translate-x-[18px]' : 'translate-x-0'
        }`}
      />
    </button>
  );
}
